<script>
    import { onMount } from "svelte";

    export let category_scores;
    let svgElement;
    let padding = 10;
    let barHeight = 20;
    let barGap = 10;
    let percentageWidth = 60;
    let labelWidth = 80;
    let width = 500;
    
    $: height = padding * 2 + Object.keys(category_scores).length * (barHeight + barGap) - barGap;

    function updateWidth() {
        width = svgElement.clientWidth;
    }

    // onMount is needed otherwise svgElement isn't defined yet
    onMount(() => {
        updateWidth();
        window.addEventListener('resize', updateWidth);
        
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    });

</script>


<svg bind:this={svgElement} height={height} class="bg-accent-light rounded-lg text-sm text-secondary-text w-full">
    {#each Object.entries(category_scores) as [key, value], index}
        <rect
            x={padding + labelWidth + padding}
            y={padding + index * (barHeight + barGap)}
            width={value * (width - 2 * padding - labelWidth - percentageWidth)}
            height={barHeight}
            fill={`hsl(${index * 50}, 70%, 50%)`}
        />
        <text
            x={padding + labelWidth}
            y={padding + index * (barHeight + barGap) + barHeight / 2}
            text-anchor="end"
            alignment-baseline="middle"
        >
            {key}
        </text>
        <text
            x={padding + labelWidth + padding + value * (width - 2 * padding - labelWidth - percentageWidth) + 5}
            y={padding + index * (barHeight + barGap) + barHeight / 2}
            text-anchor="start"
            alignment-baseline="middle"
        >
            {(value * 100).toFixed(2)}%
        </text>
    {/each}
    
</svg>